import { motion } from "framer-motion";
import { CloudUpload, Sparkles, BarChart3 } from "lucide-react";

const steps = [
  {
    icon: CloudUpload,
    number: "01",
    title: "Upload Your Ad",
    desc: "Drop any static image ad \u2014 social media, banner, print, OOH. Video coming soon.",
  },
  {
    icon: Sparkles,
    number: "02",
    title: "AI + Neuroscience Analysis",
    desc: "Our models predict where eyes go, what the brain retains, and how emotions respond \u2014 without a lab.",
  },
  {
    icon: BarChart3,
    number: "03",
    title: "Get Actionable Results",
    desc: "Heatmaps, scores, predictions, and specific recommendations to make your ad perform better.",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-24" data-testid="how-it-works-section">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif', color: '#0F172A' }}>
            From Upload to Insight in <span className="gradient-text">60 Seconds</span>
          </h2>
        </motion.div>

        <div className="relative">
          {/* Connector line (desktop) */}
          <div className="hidden md:block step-connector" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {steps.map((step, i) => (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
                data-testid={`step-card-${i}`}
                className="text-center relative"
              >
                <div className="inline-flex items-center justify-center w-[72px] h-[72px] rounded-2xl bg-gradient-to-br from-orange-500 to-fuchsia-500 mb-6 shadow-lg shadow-orange-500/20">
                  <step.icon size={28} className="text-white" />
                </div>
                <div className="text-xs font-bold text-orange-500 mb-2" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
                  STEP {step.number}
                </div>
                <h3 className="text-xl font-bold mb-3" style={{ fontFamily: 'Outfit, sans-serif', color: '#0F172A' }}>
                  {step.title}
                </h3>
                <p className="text-sm leading-relaxed max-w-xs mx-auto" style={{ color: '#475569' }}>
                  {step.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
